export default __webpack_public_path__ + "static/ForgetSectionRight_uk-2aa407617c47f6bd19b1680b527bad02.png";